// App overrides

import { CartAddEvent } from '@theme/events';

class Overrides {
  constructor() {
    this.swymWishlistApp();
    this.availabilityMirror();
  }

  swymWishlistApp() {
    this.#connectSwymAddToCartButtons();
  }

  availabilityMirror() {
    const init = () => {
      const availabilityComponent = document.querySelector('[data-product-availability]');
      const inlineDisplay = document.querySelector('[data-inline-stock-count]');

      if (!availabilityComponent || !inlineDisplay) return;

      inlineDisplay.style.cssText = 'display:none;flex-direction:row;align-items:center;gap:0.5rem;';

      const observer = new MutationObserver(() => {
        const result = availabilityComponent.querySelector('.product-availability__result-availability');
        const storeName = availabilityComponent.querySelector('.product-availability__result-name')?.textContent?.trim();

        if (result) {
          const statusText = result.textContent.trim();
          inlineDisplay.innerHTML = result.innerHTML.replace(statusText, `${statusText} at ${storeName}`);

          const svg = inlineDisplay.querySelector('svg');
          if (svg) {
            svg.setAttribute('width', '20');
            svg.setAttribute('height', '20');
            svg.style.cssText = 'width:1.25rem!important;height:1.25rem!important;min-width:1.25rem!important;max-width:1.25rem!important;flex-shrink:0;display:inline!important;';
          }

          inlineDisplay.style.cssText = 'display:flex;flex-direction:row;align-items:center;gap:0.5rem;';

          if (!availabilityComponent.querySelector('[data-clear-store]')) {
            const selectedStore = availabilityComponent.querySelector('[data-selected-store]');
            const clearBtn = document.createElement('button');
            clearBtn.setAttribute('data-clear-store', '');
            clearBtn.className = 'product-availability__clear-store button-unstyled';
            clearBtn.textContent = 'Clear store';
            selectedStore.after(clearBtn);

            clearBtn.addEventListener('click', () => {
              selectedStore.innerHTML = '';
              inlineDisplay.innerHTML = '';
              inlineDisplay.style.cssText = 'display:none;';
              const openBtn = availabilityComponent.querySelector('[data-open-drawer]');
              if (openBtn) openBtn.textContent = availabilityComponent.dataset.setStoreText;
              clearBtn.remove();
            });
          }
        }
      });

      observer.observe(availabilityComponent, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  }

  #connectSwymAddToCartButtons() {
    document.addEventListener('click', (e) => {
      if (!(e.target instanceof Element)) return;

      const button = e.target.closest(
        '.swym-storefront-layout-grid-item-add-to-cart-button'
      );
      if (!button) return;

      setTimeout(() => {
        this.#triggerCartUpdate();
      }, 1000);
    });
  }

  #triggerCartUpdate() {
    document.dispatchEvent(
      new CartAddEvent({}, '', {
        source: 'product-form',
        itemCount: 1,
      })
    );
  }
}

new Overrides();
